const scene ="feedback";

export const UPDATE_FEEDBACK_QUESTIONS = `${scene}UPDATE_FEEDBACK_QUESTIONS`;
export const UPDATE_FEEDBACK_DROPDOWN = `${scene}UPDATE_FEEDBACK_DROPDOWN`;
export const UPDATE_FEEDBACK_DETAILS = `${scene}UPDATE_FEEDBACK_DETAILS`;
export const UPDATE_FEEDBACK = `${scene}UPDATE_FEEDBACK`;
